export default "__VITE_ASSET__5b461eeb__"